import {Autoplay, Navigation, Swiper, Pagination} from "swiper";


$('.js-post-gallery-slider').each(function (i, el) {

  let swiper = new Swiper(el, {
    modules: [Autoplay, Navigation, Pagination],
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: ".swiper-pagination",
      type: "fraction",
    },
    slidesPerView: "auto",
    centeredSlides: true,
  })

})

